import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  GenderStoreActions,
  GenderStoreSelectors,
  GenderStoreReducer,
} from './index';
import { EpimsGenderDto } from '@cradua/data';

@Injectable()
export class GenderFacade {
  constructor(private store: Store<GenderStoreReducer.GenderPartialState>) {}

  genderRecord$ = this.store.select(GenderStoreSelectors.getSelected);
  genderRecordError$ = this.store.select(GenderStoreSelectors.getGenderError);

  getselected() {
    return this.store.select(GenderStoreSelectors.getSelected);
  }

  get isLoadingGender() {
    this.store.dispatch(GenderStoreActions.loadGender());
    return this.store.select(GenderStoreSelectors.loadingGender);
  }

  get loadGender() {
    this.store.dispatch(GenderStoreActions.loadGender());
    return this.store.select(GenderStoreSelectors.getAllGender);
  }

  addGender(newGender: EpimsGenderDto[]) {
    this.store.dispatch(GenderStoreActions.addGender({ newGender }));
  }

  updateGender(updateGender: EpimsGenderDto[]) {
    this.store.dispatch(GenderStoreActions.updateGender({ updateGender }));
  }

  removeGender(ids: string[]) {
    this.store.dispatch(GenderStoreActions.removeGender({ ids }));
  }
}
